import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({ standalone: true, name: 'fnCall' })
export class FnCallPipe implements PipeTransform {
  public transform<T, const U extends (...args: T[]) => any>(fn: U, ...args: T[]): ReturnType<U> {
    return fn(...args);
  }
}
